import { StyleSheet } from './compiler'

/**
 * custom DPI for page contents
 * used by all pdf types
 * Attention: changes affect direct layout
 */
export const PDF_DPI_NUMBER = 150

export const PDF_TYPES = {
  REQUIREMENT_PROFILE: 'REQUIREMENTPROFILE',
  MATCHING_PROFILE: 'MATCHINGPROFILE',
  TALENT_PROFILE: 'TALENTPROFILE',
  TEAM_PROFILE: 'TEAMPROFILE'
}

export const CATEGORY_KEYS = {
  INTERESTS: 'INTERESTS',
  CULTURE: 'CULTURE',
  PERSONALITY: 'PERSONALITY',
  SKILLS: 'SKILLS'
}

export const typoStyles = StyleSheet.create({
  H1Blue: {
    fontWeight: 600,
    fontSize: 26,
    color: '#2C46B2'
  },
  H1Black: {
    fontWeight: 600,
    fontSize: 26,
    color: '#182033'
  },
  H2Black: {
    fontWeight: 600,
    fontSize: 20,
    color: '#182033'
  },
  H4Black: {
    fontWeight: 600,
    fontSize: 16,
    color: '#182033'
  },
  H4White: {
    fontWeight: 600,
    fontSize: 16,
    color: 'white'
  },
  T1Black: {
    fontWeight: 400,
    color: '#283440',
    fontSize: 16,
    lineHeight: 1.4
  },
  T1Blue: {
    fontWeight: 400,
    color: '#2C46B2',
    fontSize: 16
  },
  T2Black: {
    fontWeight: 400,
    fontSize: 14,
    color: '#283440'
  },
  T2Blue: {
    fontWeight: 400,
    fontSize: 14,
    color: '#2C46B2'
  },
  T2MediumBlue: {
    fontWeight: 500,
    color: '#2C46B2',
    fontSize: 14
  },
  T2BlackBold: {
    fontWeight: 700,
    fontSize: 14,
    color: '#283440'
  },
  ButtonBlue: {
    fontWeight: 500,
    fontSize: 14,
    color: '#3D7BF3'
  },
  Button: {
    fontWeight: 500,
    fontSize: 14
  },
  SmallBlack: {
    fontSize: 12,
    color: '#45586B',
    fontWeight: 400
  },
  SmallWhite: {
    fontSize: 12,
    color: 'white',
    fontWeight: 600 // 600
  },
  SmallBlue: {
    fontSize: 12,
    color: '#2C46B2',
    fontWeight: 600
  }
})

export const colors = {
  lightPaleGrey: '#FAFBFC',
  paleGray: '#F5F7FA',
  lightGrey: '#EBF0F5',
  darkGray: '#283440',
  darkBlue: '#2C46B2',
  primaryBlue: '#4461D4',
  brightBlue: '#3D7BF3',
  lightBlue: '#B6C7F2',
  paleBlue: '#DFE4FC',
  paleWhiteBlue: '#EBEFFD',
  rockGrey: '#45586B',
  secondaryYellow: '#FFB629',
  brightGreen: '#4FF0D0',
  darkRed: '#9D174D',
  mediumRed: '#FE78A7',
  lightRed: '#FCE7F3',
  darkGreen: '#0F6856',
  mediumGreen: '#4FF0D0',
  lightGreen: '#C7FFF4',
  darkYellow: '#774E00',
  mediumYellow: '#FFB629',
  lightYellow: '#FFE7B9',
  darkBlack: '#182033',
  softGrey: '#D1DBE6'
}

export const RIASEC_SCORES = [
  'RIASEC_IMAGES_r_score',
  'RIASEC_IMAGES_i_score',
  'RIASEC_IMAGES_a_score',
  'RIASEC_IMAGES_s_score',
  'RIASEC_IMAGES_e_score',
  'RIASEC_IMAGES_c_score'
]
